( function ( root, factory ) {
    if ( typeof define === 'function' && define.amd ) {
        define([
            'jquery'
        ], factory );
    } else if ( typeof exports === 'object' ) {
        // Node, CommonJS-like
        module.exports = factory(
            require( 'jquery' )
        );
    } else {
        // Browser globals (root is window)
        root.MediaTimer = factory(
            root.jQuery
        );
    }
} )( this, function ( $ ) {
    function MediaTimer ( wiretapVideo ) {
        if ( ! wiretapVideo ) {
            return;
        }

        this.wiretapVideo   = wiretapVideo;
        this.dispatcher     = this.wiretapVideo.bandwagon.getInstanceByKey( '#video-player' );
        this.intervalEvents = this.wiretapVideo.trackingConfig.intervals;
        this.eventDefaults  = this.wiretapVideo.trackingConfig.defaults;

        _initListeners.call( this );
    }

    MediaTimer.prototype = {
        init: function () {
            if ( ! this.player || ! this.player.clip ) {
                return;
            }

            this.clip         = this.player.clip;
            this.videoLength  = this.player.clip.duration ? this.player.clip.duration * 1000 : 0;
            this.isTracking   = false;
            this.totalTime    = 0;
            this.hasTracked   = false;
            this.mediaStarted = true;

            this.start();
        },
        start: function () {
            if ( ! this.isTracking && this.mediaStarted ) {
                this.startTime = new Date();
                this.isTracking = true;
            }
        },
        stop: function () {
            if ( this.isTracking ) {
                this.stopTime = new Date();
                this.isTracking = false;
                this.setInterval();
            }
        },
        setInterval: function () {
            var interval = 0;
            if ( this.startTime && this.stopTime ) {
                interval = this.stopTime - this.startTime;
            }

            this.totalTime += interval;
            this.startTime = null;
            this.stopTime = null;
        },
        startTracking: function ( data, event ) {
            if ( this.isTracking ) { // Track previous media.
                this.stop();
                this.track();
            }

            this.player = data.player || this.player;

            this.init();
        },
        track: function () {
            if ( this.hasTracked || ! this.videoLength ) {
                return;
            }

            var self = this;
            var adobeObj = {};

            if ( this.isTracking ) {
                this.stop();
            }

            // TODO - an event like onBeforeChangeVidSrc would be better.
            // Track using the timer's active clip, not the player's current clip.
            var player = $.extend( {}, self.player );
            player.clip = self.clip;
            var clipDuration = player.clip.metaData.duration;
            var durationSplit = clipDuration.split(':');
            var clipDurationSeconds = 0;

            if (durationSplit.length === 3) {
                clipDurationSeconds = (+durationSplit[0]) * 60 * 60 + (+durationSplit[1]) * 60 + (+durationSplit[2]);
            } else if (durationSplit.length === 2) {
                clipDurationSeconds = (+durationSplit[0]) * 60 + (+durationSplit[1]);
            } else {
                clipDurationSeconds = (+durationSplit[1]);
            }

            var clipDurationMinutes = _getMinutes(clipDurationSeconds);
            var clipDurationSecondsModulo = _getSeconds(clipDurationSeconds);

            $.each( self.intervalEvents, function( index, event ) {
                var eventTime = clipDurationSeconds * event.wire.duration;
                var eventTimeMinutes = _getMinutes(eventTime);
                var eventTimeSeconds = _getSeconds(eventTime);
                if ( self.videoLength >= self.videoLength * event.wire.duration ) {
                    var trackObj = $.extend( {}, self.eventDefaults[ event.wire.defaults ], event );

                    self.wiretapVideo.setTrackingProps( trackObj, { player: player } );
                    if ( trackObj ) {
                        self.wiretapVideo.prototype.track( trackObj );
                    }
                }
            } );

            this.isTracking = false;
            this.hasTracked = true;
            this.mediaStarted = false;
        }
    };

    function _getMinutes(time) {
        var mins = Math.floor(time / 60).toString();
        if (mins < 10) {
            return '0' + mins;
        } else {
            return mins;
        }
    }

    function _getSeconds(time) {
        var secs = Math.floor(time % 60).toString();
        if (secs < 10) {
            return '0' + secs;
        } else {
            return secs;
        }
    }

    function _initListeners() {
        // Init and start timer.
        this.dispatcher.on( this.wiretapVideo.PlayerEvents['MEDIA_START'], this.startTracking.bind( this ) );

        // Start timer.
        this.dispatcher.on( this.wiretapVideo.PlayerEvents['MEDIA_RESUME'], this.start.bind( this ) );
        this.dispatcher.on( this.wiretapVideo.AdEvents['AD_COMPLETE'], this.start.bind( this ) );

        // Stop timer.
        this.dispatcher.on( this.wiretapVideo.PlayerEvents['MEDIA_PAUSED'], this.stop.bind( this ) );
        this.dispatcher.on( this.wiretapVideo.AdEvents['AD_START'], this.stop.bind( this ) );

        // Track.
        this.dispatcher.on( this.wiretapVideo.PlayerEvents['MEDIA_COMPLETE'], this.track.bind( this ) );
        window.addEventListener( "beforeunload", this.track.bind( this ) );
    }

    return MediaTimer;
});